<div class="steps clearfix" *ngIf="app.config.showSteps">
    <ul role="tablist">
        <li role="tab" class="first" [ngClass]="{'current' : step ===1 || step ===2 || step ===3 || step ===4}" aria-disabled="false" aria-selected="true">
            <a id="form-total-t-0" aria-controls="form-total-p-0">
                <!-- <span class="current-info audible"></span> -->
                <div class="title" *ngIf="app.customer==null">
                    <span class="step-icon"><i class="far fa-calendar-alt"></i></span>
                    <span class="step-number">&nbsp;</span>
                    <span class="step-text">{{app.config.stepAppointment}}</span>
                </div>
                <div class="title" *ngIf="app.customer!=null">
                    <span class="step-icon"><i class="far fa-address-card"></i></span>
                    <span class="step-number">&nbsp;</span>
                    <span class="step-text">{{app.config.stepLogin}}</span>
                </div>
            </a>
        </li>
        <li role="tab" class="" [ngClass]="{'current' : step ===2 || step ===3 || step ===4}" aria-disabled="true">
            <a id="form-total-t-1" aria-controls="form-total-p-1">
                <div class="title" *ngIf="app.customer!=null">
                    <span class="step-icon"><i class="far fa-list-alt"></i></span>
                    <span class="step-number">&nbsp;</span>
                    <span class="step-text">{{app.config.stepAppointment}}</span>
                </div>
                <div class="title" *ngIf="app.customer==null">
                    <span class="step-icon"><i class="far fa-address-card"></i></span>
                    <span class="step-number">&nbsp;</span>
                    <span class="step-text">{{app.config.stepLogin}}</span>
                </div>
            </a>
        </li>
        <li role="tab" class="" [ngClass]="{'current' : step ===3 || step ===4}" aria-disabled="true">
            <a id="form-total-t-2" aria-controls="form-total-p-2">
                <div class="title">
                    <span class="step-icon"><i class="fas fa-shopping-cart"></i></span>
                    <span class="step-number">&nbsp;</span>
                    <span class="step-text">{{app.config.stepConfirm}}</span>
                </div>
            </a>
        </li>
        <li role="tab" class="last" [ngClass]="{'current' : step ===4}" aria-disabled="true"><a id="form-total-t-2"
                aria-controls="form-total-p-2">
                <div class="title">
                    <span class="step-icon"><i class="far fa-calendar-check"></i></span>
                    <span class="step-number">&nbsp;</span>
                    <span class="step-text">{{app.config.stepComplete}}</span>
                </div>
            </a></li>
    </ul>
</div>